import { getToken } from '@helpscout/hsds-tokens/getToken'
import { css } from 'styled-components'

export const generateLinkStyles = () => css`
  color: ${getToken('link.color.default')};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: ${getToken('link.color.hover')};
    outline-width: 0;
    text-decoration: underline;
  }

  &:active {
    color: ${getToken('link.color.active')};
    outline-width: 0;
  }
`
